import { fetchConToken } from '../helpers/fetch';

const AfiliadoDiscapacidadService = {
    getDataContacto : (idAfiliado) => {
        return fetchConToken(`Afiliados/traerPorIdAfiliado/${idAfiliado}`)
    },
    getDiasDisponibles: (idEspecialidad, idCentroMedico, idProfesional, virtual)=>{
        if(idProfesional){
            return fetchConToken(`Agenda/traerDias?idEspecialidad=${idEspecialidad}&idCentroMedico=${idCentroMedico}&presencial=${true}&videoConsulta=${virtual}&idProfesional=${idProfesional}`)
        }else{
            return fetchConToken(`Agenda/traerDias?idEspecialidad=${idEspecialidad}&idCentroMedico=${idCentroMedico}&presencial=${true}&videoConsulta=${virtual}`)
        }
    },
    getPrimerTurnoDisponible:(idEspecialidad, idCentroMedico, idProfesional, virtual)=>{
        if(idProfesional){
            return fetchConToken(`Agenda/traerPrimeroDisponible?idEspecialidad=${idEspecialidad}&idCentroMedico=${idCentroMedico}&presencial=${true}&videoConsulta=${virtual}&idProfesional=${idProfesional}`)
        }else{
            return fetchConToken(`Agenda/traerPrimeroDisponible?idEspecialidad=${idEspecialidad}&idCentroMedico=${idCentroMedico}&presencial=${true}&videoConsulta=${virtual}`)
        }
    },
    getTurnosDisponibles:(idEspecialidad, idCentroMedico, idProfesional, virtual, fecha, hora)=>{

        if(hora && idProfesional){
            return fetchConToken(`Agenda/traerDisponibles?idEspecialidad=${idEspecialidad}&idCentroMedico=${idCentroMedico}&presencial=${true}&videoConsulta=${virtual}&idProfesional=${idProfesional}&fecha=${fecha}&hora=${hora}`)
        }else if(hora){
            return fetchConToken(`Agenda/traerDisponibles?idEspecialidad=${idEspecialidad}&idCentroMedico=${idCentroMedico}&presencial=${true}&videoConsulta=${virtual}&fecha=${fecha}&hora=${hora}`)
        }else if(idProfesional){
            return fetchConToken(`Agenda/traerDisponibles?idEspecialidad=${idEspecialidad}&idCentroMedico=${idCentroMedico}&presencial=${true}&videoConsulta=${virtual}&idProfesional=${idProfesional}&fecha=${fecha}`)
        }
    },
    getHorasDisponibles:(idEspecialidad, idCentroMedico, virtual, fecha)=>{
        return fetchConToken(`Agenda/traerHoras?idEspecialidad=${idEspecialidad}&idCentroMedico=${idCentroMedico}&presencial=${true}&videoConsulta=${virtual}&fecha=${fecha}`)
    },
    confirmarTurno:(data)=>{
        return fetchConToken(`Agenda/confirmarTurno`, data, "PUT")
    },
    cancelarTurno:(data)=>{
        return fetchConToken(`Agenda/cancelarTurno`, data, "PUT")
    },
    getMisTurnos:(idAfiliado)=>{
        return fetchConToken(`Agenda/traerPorAfiliado?idAfiliado=${idAfiliado}`)
    },
    getMisTurnosConcurridos:(idAfiliado)=>{
        return fetchConToken(`Agenda/traerPorAfiliado?idAfiliado=${idAfiliado}&tipoConsulta=2`)
    },
    getMotivosBaja:()=>{
        return fetchConToken(`MotivosdeBajaTurno`)
    },
    getDetalleTurno:(idAgenda)=>{
        return fetchConToken(`Agenda/traerDetalleTurno/${idAgenda}`)
    }
}

export {AfiliadoDiscapacidadService as default}